import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row" }
const _hoisted_2 = { class: "text-center navbar-brand-wrapper d-flex align-items-center justify-content-center" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("ダッシュボード")
const _hoisted_4 = { class: "navbar-menu-wrapper d-flex align-items-center justify-content-between" }
const _hoisted_5 = { class: "top-navbar-area navbar-nav navbar-nav-right" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<li class=\"nav-item dropdown dropdown-animate\"><a class=\"nav-link count-indicator dropdown-toggle\" id=\"notificationDropdown\" href=\"#\" data-toggle=\"dropdown\"><i class=\"fa fa-bell-o\"></i><span class=\"count\"></span></a><div class=\"dropdown-menu dropdown-menu-right navbar-dropdown preview-list\" aria-labelledby=\"notificationDropdown\"><p class=\"mb-0 font-weight-normal float-left dropdown-header\"> Notifications </p><a class=\"dropdown-item preview-item d-flex align-items-center\"><div class=\"notification-thumbnail\"><div class=\"preview-icon bg-primary\"><i class=\"ti-info-alt mx-0\"></i></div></div><div class=\"notification-item-content\"><h6>Code problem solved.</h6><p class=\"mb-0\">Just now</p></div></a><a class=\"dropdown-item preview-item d-flex align-items-center\"><div class=\"notification-thumbnail\"><div class=\"preview-icon bg-success\"><i class=\"ti-info-alt mx-0\"></i></div></div><div class=\"notification-item-content\"><h6>New theme update.</h6><p class=\"mb-0\">02 days ago</p></div></a><a class=\"dropdown-item preview-item d-flex align-items-center\"><div class=\"notification-thumbnail\"><div class=\"preview-icon bg-warning\"><i class=\"ti-info-alt mx-0\"></i></div></div><div class=\"notification-item-content\"><h6>Awsome support.</h6><p class=\"mb-0\">02 days ago</p></div></a><a class=\"dropdown-item preview-item d-flex align-items-center\"><div class=\"notification-thumbnail\"><div class=\"preview-icon bg-danger\"><i class=\"ti-info-alt mx-0\"></i></div></div><div class=\"notification-item-content\"><h6>Text to build on the card title.</h6><p class=\"mb-0\">03 days ago</p></div></a></div></li>", 1)
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "badge badge-light" }
const _hoisted_9 = { class: "nav-item nav-profile dropdown dropdown-animate" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle",
  href: "#",
  "data-toggle": "dropdown",
  id: "profileDropdown"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-bars" })
], -1)
const _hoisted_11 = {
  class: "dropdown-menu dropdown-menu-right navbar-dropdown profile-top",
  "aria-labelledby": "profileDropdown"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", {
  class: "zmdi zmdi-account profile-icon",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("ユーザー管理")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("form", {
  method: "post",
  action: "/api/auth/logout?redirect=/login"
}, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "submit",
    class: "dropdown-item",
    value: "ログアウト"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "navbar-brand",
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("ul", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("li", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(this.currentUser?.userName), 1)
        ]),
        _createElementVNode("li", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            (_ctx.basicUtil.hasRole(_ctx.currentUser.role, 0))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "/user",
                  class: "dropdown-item"
                }, {
                  default: _withCtx(() => [
                    _hoisted_12,
                    _hoisted_13
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _hoisted_14
          ])
        ])
      ])
    ])
  ]))
}